import React from 'react';
import { Globe } from 'lucide-react';
import { useLanguage } from '@/context/LanguageContext';
import { cn } from '@/lib/utils';

export default function LanguageSwitcher({
  compact = false,
  className = '',
  showLabel = true,
}) {
  const { language, changeLanguage, arabicEnabled } = useLanguage();

  if (!arabicEnabled) {
    return null;
  }

  const isArabic = language === 'ar';

  const handleToggle = (e) => {
    e.stopPropagation();
    changeLanguage(isArabic ? 'en' : 'ar');
  };

  const targetLabel = isArabic ? 'English' : 'العربية';
  const targetTitle = isArabic ? 'Switch to English' : 'التحويل إلى العربية';

  if (compact) {
    return (
      <button
        type="button"
        onClick={handleToggle}
        className={cn(
          "relative flex items-center justify-center p-2 rounded-xl text-muted-foreground hover:text-foreground hover:bg-[hsl(var(--sidebar-hover))] transition-all duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-[hsl(var(--teal-vivid))]",
          className
        )}
        title={targetTitle}
        aria-label={targetTitle}
      >
        <Globe className="w-5 h-5 shrink-0" />
        <span className="absolute -bottom-1 -right-1 text-[9px] font-extrabold uppercase bg-[hsl(var(--teal-vivid))] text-white px-1 py-0.2 rounded-full leading-none shadow-sm">
          {isArabic ? 'EN' : 'AR'}
        </span>
      </button>
    );
  }

  return (
    <button
      type="button"
      onClick={handleToggle}
      className={cn(
        "inline-flex items-center gap-1.5 px-2.5 py-1.5 rounded-xl text-xs font-semibold text-muted-foreground hover:text-foreground bg-[hsl(var(--sidebar-hover))]/40 hover:bg-[hsl(var(--sidebar-hover))] border border-[hsl(var(--card-border))] transition-all duration-200 shadow-sm focus:outline-none focus-visible:ring-2 focus-visible:ring-[hsl(var(--teal-vivid))]",
        className
      )}
      title={targetTitle}
      aria-label={targetTitle}
    >
      <Globe className="w-4 h-4 text-[hsl(var(--teal-vivid))] shrink-0" />
      {showLabel && (
        <span className="font-medium text-foreground tracking-normal">
          {targetLabel}
        </span>
      )}
    </button>
  );
}
